import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/projects'

/**
 * Flag target service for listing targets by flag.
 */
class FlagTargetService {
    /**
     * List targets for a flag.
     *
     * @param {string} projectKey - Project key
     * @param {string} flagKey - Flag key
     * @returns {Promise<Object>} Target list response
     */
    async list(projectKey, flagKey) {
        return await apiClient
            .get(API_INTERNAL_BASE + `/${projectKey}/flags/${flagKey}/targets`)
            .then((response) => {
                return response.data
            })
    }
}

export default new FlagTargetService()
